import { render, staticRenderFns } from "./zmAllocation.vue?vue&type=template&id=1df0c9de"
import script from "./zmAllocation.vue?vue&type=script&lang=js"
export * from "./zmAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports